export default {
    invoices:[
        {
            label: 'Оплаты',
            value: 1,
        },
        {
            label: 'Реализации',
            value: 2,
        },
        {
            label: 'Создания',
            value: 3,
        },
    ],
    regulars:[
        {
            label: 'Платежа',
            value: 1,
        },
        {
            label: 'Создания',
            value: 2,
        },
        {
            label: 'Оплаты',
            value: 3,
        },
    ],
    payments:[
        {
            label: 'Создания',
            value: 1,
        },
        {
            label: 'Платежа',
            value: 2,
        },
        {
            label: 'Изменения',
            value: 3,
        },
    ],
    statements:[
        {
            label: 'Загрузки',
            value: 1,
        },
        {
            label: 'Платежа',
            value: 0,
        },
    ],
    certificates:[
        {
            label: 'Выдачи',
            value: 1,
        },
        {
            label: 'Начала',
            value: 2,
        },
        {
            label: 'Окончания',
            value: 3,
        },
        {
            label: 'Создания',
            value: 4,
        },
    ],
}
